export default function(value) {
  const el = document.createElement('div');
  el.innerHTML = value;

  // replace multi lines with hrs
  // replace title-ish lines at start of hrs with h1s/h2s

  return el.innerHTML
}